/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { ComponentInterface } from '@appCanvasCommon/interfaces/component.interface';
import { TicketContainer, TICKET_CHANGE_EVENTS } from '../tickets/TicketContainer';
import { Texture } from 'pixi.js-legacy';
import { TicketComponentHelper } from './TicketComponentHelper';
import { Side } from '@touchplan/common';
import { CanvasAngularLand } from 'src/app/app-data/interfaces/canvas-angular-land';
import { TicketType } from '@touchplan/common';
import { setTicketWidthHelper } from 'src/app/utils/ticket-utils';
import { EventMode } from '@appCanvasCommon/events/event-mode.enum';

export class TicketLocation extends TicketComponentHelper implements ComponentInterface {
	constructor(texture: Texture, canvasAngularLand: CanvasAngularLand, ticketContainer: TicketContainer) {
		super(texture, canvasAngularLand, ticketContainer);

		ticketContainer.on(TICKET_CHANGE_EVENTS.CHANGED, this.onChanged);

		this.onChanged(ticketContainer);
		this.eventMode = EventMode.None;
	}

	private onChanged = (ticketContainer: TicketContainer) => {
		const data = ticketContainer.getData();
		const layout = ticketContainer.getLayout();
		if (!data.view.location) {
			this.renderable = false;
		} else {
			this.renderable = true;
			this.tint = this.ticket.locationColor;
			this.ticket.locationContainer = this;
			this.width = setTicketWidthHelper(data, layout, this.canvasAngularLand.wideTicketSize$.getValue());
			this.height = data.view.side === Side.PULL ? 40 : 25;
		}
	};

	public update(_: CanvasAngularLand, ticketContainer: TicketContainer) {
		if (this.renderable && this.visible && this.active) {
			const data = ticketContainer.getData();
			const layout = ticketContainer.getLayout();
			this.width = setTicketWidthHelper(data, layout, this.canvasAngularLand.wideTicketSize$.getValue());
			this.height = data.view.side === Side.PULL ? 40 : 25;
		}
	}

	public override destroy(options?) {
		this.ticket.off(TICKET_CHANGE_EVENTS.CHANGED, this.onChanged);
		super.destroy(options);
	}
}
